import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Type20Service {

  private subtype = new BehaviorSubject<string[]>([]);
  public customOption = this.subtype.asObservable();
  public type:number;
  constructor() {}
  public changeOption(id:number,subtype:any[]): void {
    this.type = id;
    this.subtype.next(this.store(id,subtype));
  }

  public resolveTypeId(value: any, types: any[]): number | string | '' {
    if (!value) {
      return '';
    }
    if (value.idtype != null && value.idtype !== '') {
      return value.idtype;
    }
    if (!value.type || !Array.isArray(types)) {
      return '';
    }
    const found = types.find((row) => row && row.name === value.type);
    return found ? found.id : '';
  }

  public store(id:number,subtype: any[]):string[]{
    if (!Array.isArray(subtype)) {
      return [];
    }
    const data = subtype.find((el) => Number(id) === Number(el && el.typeId));
    return data && Array.isArray(data.items) ? data.items : [];
  }
  public getType():number{
   return this.type
  }
}
